<template>
  <el-dialog title="三方媒资信息"
             v-if="value"
             :visible.sync="value"
             width="800px"
             :modal-append-to-body="false"
             :before-close="handleClose">

    <el-row style="margin:0 0 20px 50px;">
      <el-col :span="11"> <span style="display: inline-block; width: 100px;">三方媒资 ID：</span> {{row.partnerData ? row.partnerData.partnerMediaId || '--' : '--' }}</el-col>
      <el-col :span="2"> </el-col>
      <el-col :span="11"> <span style="display: inline-block; width: 100px;">三方分集状态：</span> {{row.partnerData ? ({0:'已下架',1:'已上架'}[row.partnerData.partnerMediaStatus] || '--') : '--' }}</el-col>
    </el-row>

    <el-row style="margin:0 0 20px 50px;">
      <el-col :span="11"> <span style="display: inline-block; width: 100px;">版权标识 ：</span> {{  row.partnerData ? row.partnerData.copyrightMediaCode || '--' : '--' }}</el-col>
      <el-col :span="2"> </el-col>
      <el-col :span="11"> <span style="display: inline-block; width: 100px;">版权商 ID：</span> {{ row.partnerData ? row.partnerData.copyrightMediaId || '--' : '--'}}</el-col>
    </el-row>

    <!-- <el-row style="margin:0 0 20px 50px;">
      <el-col :span="11"> <span style="display: inline-block; width: 100px;">是否独播：</span> {{ 2023011221003 }}</el-col>
      <el-col :span="2"> </el-col>
      <el-col :span="11"> <span style="display: inline-block; width: 100px;">来源：</span> {{ 2023011221003 }}</el-col>
    </el-row>

    <el-row style="margin:0 0 20px 50px;">
      <el-col :span="24"> <span style="display: inline-block; width: 100px;">分组名称：：</span> {{ 2023011221003 }}</el-col>
    </el-row> -->

  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => { return { aa: 123 } }
    },
  },
  data () {
    return {

    };
  },
  methods: {
    handleClose (done) {
      this.$emit('input', false)
      done();
    }
  }
};
</script>

<style>
</style>